var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('Form',{attrs:{"chart-id":_vm.chartId,"schema-endpoint":"analytics/schema","chart-endpoint":"enroll_admin/chart","validation":_vm.validation},on:{"submit":_vm.handleSubmit,"cancel":function($event){return _vm.$router.push('/dashboard')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }